/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalService, ToastrTranslationsNotificationService } from 'app/shared/services';
import { UserData } from '@shared/models/user.model';

@Component({
  selector: '[profileContactModal]',
  templateUrl: './profile-contact-modal.component.html',
  styleUrls: ['./profile-contact-modal.component.scss'],
})
export class ProfileContactModalComponent implements OnInit {
  @Input() userData: UserData;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @ViewChild('emailCopyContainer') emailCopyContainer: ElementRef;

  contactsList: { name: string; details: string; email: string; phone: string; avatar?: string }[] = [];
  defaultAvatar = '/assets/images/svg/rebrand/athlete-default.svg';

  constructor(
    private modalService: ModalService,
    private toastrTranslationsNotificationService: ToastrTranslationsNotificationService
  ) {}

  ngOnInit() {
    this.contactsList.push({
      avatar: this.userData.image.urlThumb,
      name: this.userData.firstName + ' ' + this.userData.lastName,
      details: `${this.userData.userDetails.positions || ''} ${this.userData.userDetails.gradYear || ''}`,
      email: this.userData.userDetails.contactEmail,
      phone: this.userData.userDetails.contactPhone,
    });

    if (this.userData.userDetails && this.userData.userDetails.schoolName) {
      this.contactsList.push({
        name: this.userData.userDetails.coachName,
        details: `Coach, ${this.userData.userDetails.schoolName}`,
        email: this.userData.userDetails.coachEmail,
        phone: this.userData.userDetails.coachPhone,
      });
    }

    if (this.userData.clubs && this.userData.clubs.length) {
      this.contactsList.push(
        ...this.userData.clubs.map((club) => ({
          name: club.coachName,
          details: `Coach, ${club.name}`,
          email: club.coachEmail,
          phone: club.coachPhone,
        }))
      );
    }
  }

  close() {
    this.modalService.hideModal();
    this.closeModal.emit(null);
  }

  copyEmail(contact) {
    const textarea = document.createElement('textarea');
    const fieldContainer = this.emailCopyContainer.nativeElement;
    textarea.style.position = 'absolute';
    textarea.value = contact.email;
    fieldContainer.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    fieldContainer.removeChild(textarea);

    this.toastrTranslationsNotificationService.showNotification(
      'SHARED.COMPONENTS.PROFILE_CONTACT.EMAIL_COPY_NOTIFICATION'
    );
  }
}
